'use client';

import Script from 'next/script';
import { useI18n } from '~/features/i18n';
import type { I18N_CONF } from '@funkey/locales/config';
import type { StoryblokBlokProps } from './utils';
import type { SB_ReviewBlockProps } from './types.generated';

export const ReviewBlock: React.FC<StoryblokBlokProps<SB_ReviewBlockProps>> = _props => {
    const i18n = useI18n();

    return (
        <div className="relative text-blue">
            <Script
                src="https://static.elfsight.com/platform/platform.js"
                async
                strategy="afterInteractive"
            />
            <div className={REVIEW_BUCKET_LANGUAGE_MAP[i18n.language]} data-elfsight-app-lazy />
        </div>
    );
};

const REVIEW_BUCKET_LANGUAGE_MAP: Record<I18N_CONF.Language, string> = {
    nl: 'elfsight-app-5394a137-9f7a-48ce-a558-1f284723b654',
    fr: 'elfsight-app-4c9fa3b1-cdbb-4f4b-9d9f-189e37593def',
    en: 'elfsight-app-b7276090-43c9-489b-b4c6-39e156bf12f4',
};
